// frontend/src/components/common/MobileTabSelect.js
//
// Mobile section navigation for the Manager Portal: a dropdown picker that
// replaces a horizontally-scrolling tab strip on small screens (it shows the
// current section + reveals all sections in a menu — no scrolling / cut labels).
// Use ONLY on mobile (gate with useIsMobile); desktop keeps its tab strip.
import React, { useState } from 'react';
import { C } from '../../styles/theme';

const FONT = "'Plus Jakarta Sans', sans-serif";

/**
 * @param {object} props
 * @param {Array<{key:string, label:string}>} props.tabs
 * @param {string} props.active            active tab key
 * @param {(key:string)=>void} props.onChange
 * @param {string} [props.label='Section'] small caption above the current label
 */
export default function MobileTabSelect({ tabs, active, onChange, label = 'Section' }) {
    const [open, setOpen] = useState(false);
    const current = tabs.find(tb => tb.key === active) || tabs[0] || {};

    return (
        <div style={{ position: 'relative', marginBottom: 18, zIndex: 5, fontFamily: FONT }}>
            <button
                onClick={() => setOpen(o => !o)}
                style={{
                    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '13px 16px', borderRadius: 12, border: `1.5px solid ${C.border}`,
                    background: C.white, cursor: 'pointer', fontFamily: FONT,
                }}
            >
                <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, minWidth: 0 }}>
                    <span style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: C.mutedLight }}>{label}</span>
                    <span style={{ fontSize: 15, fontWeight: 800, color: C.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '78vw' }}>{current.label}</span>
                </span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={C.muted} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'none' }}><polyline points="6 9 12 15 18 9" /></svg>
            </button>
            {open && (
                <>
                    <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 40 }} />
                    <div style={{ position: 'absolute', top: 'calc(100% + 6px)', left: 0, right: 0, zIndex: 41, background: C.white, borderRadius: 12, border: `1px solid ${C.border}`, boxShadow: '0 12px 28px rgba(16,24,40,.14)', overflow: 'hidden', maxHeight: '60vh', overflowY: 'auto' }}>
                        {tabs.map((tab, i) => {
                            const isActive = active === tab.key;
                            return (
                                <button
                                    key={tab.key}
                                    onClick={() => { onChange(tab.key); setOpen(false); }}
                                    style={{
                                        width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                        padding: '13px 16px', border: 'none', cursor: 'pointer', fontFamily: FONT,
                                        background: isActive ? C.greenLight : C.white,
                                        color: isActive ? C.green : C.text, fontSize: 14, fontWeight: isActive ? 800 : 600,
                                        borderTop: i === 0 ? 'none' : `1px solid ${C.border}`, textAlign: 'left',
                                    }}
                                >
                                    {tab.label}
                                    {isActive && (
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={C.green} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </>
            )}
        </div>
    );
}
